<template>
  <v-list-tile avatar style="padding: 0 0 12px">
    <v-list-tile-avatar size="24px" class="avatar-style">
      <v-img :src="user.profile_image ? `${$storage}/user/profile/${user.profile_image}` : profileImageSrc"></v-img>
    </v-list-tile-avatar>

    <v-list-tile-content>
      <v-list-tile-title>
        <v-layout row class="justify-space-between" style="padding-top: 12px;">
          <span class="user-name" v-text="user.name">{{ user.name }}</span>
          <span class="time-text">{{ published }}</span>
        </v-layout>
      </v-list-tile-title>
      <v-list-tile-content class="mt-1">
        <v-layout row>
          <v-img v-for="n of 5" :key="n" width="12px" height="12px" class="d-inline-block"
                 :src="n <= reviewScore ? require(`@/assets/img/icon-star-active.png`) : require(`@/assets/img/icon-star-deactive.png`)">
          </v-img>
        </v-layout>
      </v-list-tile-content>
      <v-list-tile-title class="body-2" v-text="contents"></v-list-tile-title>
    </v-list-tile-content>

  </v-list-tile>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { timeToDotString } from '@/util/util';

  export default {
    name: 'ReviewListTile',
    props: [ 'idx', 'createdAt', 'updatedAt', 'contents', 'user', 'reviewScore' ],
    computed: {
      ...mapGetters([ 'now' ]),
      ...mapGetters('user', { userIdx: 'idx' }),
      profileImageSrc () {
        return require('@/assets/img/profile-default.png');
      },
      published () {
        return timeToDotString(this.createdAt, this.updatedAt, this.now);
      }
    },
  }
</script>

<style lang="scss" scoped>
  /deep/ .v-list__tile {
    min-height: 82px;
    height: auto;

    padding: 0;
    align-items: flex-start;
  }

  .avatar-style {
    min-width: 0;
    padding-top: 12px;
    padding-right: 16px;
    flex-grow: 0;
    flex-shrink: 0;
  }

  .body-2 {
    height: auto;
    white-space: normal;
    word-break: keep-all;
    word-wrap: break-word;
  }

  .user-name {
    height: auto;
    font-size: 12px;
    font-weight: 700;
    line-height: 12px;
    letter-spacing: -0.2px;
    color: map_get($colors, charcoal);
  }

  .time-text {
    color: map_get($colors, brownish-grey);
    font-size: 10px;
    line-height: 14px;
    letter-spacing: -0.3px;
  }
</style>
